import { z } from "zod";

export const sivDataCreatedPayloadSchema = z.object({
  brand: z.string(),
  model: z.string(),
  firstCirculationDate: z.iso.datetime(),
  color: z.string(),
});

export type SivDataCreatedPayload = z.infer<typeof sivDataCreatedPayloadSchema>;
